import React from "react";
import PageHeader from "../../components/ui/PageHeader";
import Card from "../../components/ui/Card";

const CouponsPage: React.FC = () => {
    return (
        <div className="page-content">
            <PageHeader
                title="Купоны"
                description="Купоны с фиксированной скидкой и сроком действия."
            />

            <Card>
                <h3 className="card-title">Купоны</h3>
                <p className="card-text">
                    Здесь позже будет управление купонами, примечаниями и сроками действия.
                </p>
            </Card>
        </div>
    );
};

export default CouponsPage;
